<template>
  <b-container v-if="this.$root.token">
    <br>
    <h3>Industry Data</h3>
    <br>
    <b-tabs>
      <b-tab title="Gears and Scores">
        <industry-score-gear-lines/>
      </b-tab>
      <b-tab title="Industry Averages">
        <industry-score-gear-bars/>
      </b-tab>
      <b-tab title="Elements">
        <industry-elements/>
      </b-tab>
    </b-tabs>
  </b-container>
</template>
<script>

import IndustryScoreGearLines from "@/components/IndustryScoreGearLines.vue";
import IndustryScoreGearBars from "@/components/IndustryScoreGearBars.vue";
import IndustryElements from "@/components/IndustryElements.vue";

export default {
  name: "IndustryData",
  components: {
    IndustryScoreGearLines,
    IndustryScoreGearBars,
    IndustryElements
  }
}
</script>
<style>
.buttonbar {
  padding-top: 4em;
  padding-bottom: 4em;
}
</style>



// WEBPACK FOOTER //
// src/views/IndustryData.vue